import React from "react";
import styled from "styled-components";

interface AdminPlaceholderPageProps {
  title: string;
  description: string;
}

const Page = styled.section`
  min-height: 100%;
`;

const HeroCard = styled.div`
  padding: clamp(28px, 4vw, 44px);
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 28px;
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.colors.shadow};
`;

const Eyebrow = styled.span`
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  color: ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.primarySoft};
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const Title = styled.h1`
  margin-top: 18px;
  color: ${({ theme }) => theme.colors.text};
  font-size: clamp(30px, 4vw, 48px);
  line-height: 1.08;
  letter-spacing: -0.045em;
`;

const Description = styled.p`
  max-width: 720px;
  margin-top: 16px;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: clamp(15px, 2vw, 17px);
  line-height: 1.8;
`;

const AdminPlaceholderPage: React.FC<AdminPlaceholderPageProps> = ({ title, description }) => {
  return (
    <Page>
      <HeroCard>
        <Eyebrow>Neural OS</Eyebrow>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </HeroCard>
    </Page>
  );
};

export default AdminPlaceholderPage;
